import React from 'react';

import {
	Typography,
	Button,
	Radio,
	RadioGroup,
	FormControlLabel,
	FormControl,
	TextField,
	Card,
	CardContent,
	Select,
	MenuItem,
	FormGroup
} from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';

import { CheckboxDemand } from './Components/CheckboxDemand';

const useStyle = makeStyles(() => ({
	card: {
		display: 'flex',
		width: '70%',
		placeSelf: 'center',
		flexDirection: 'column',
		marginTop: 10,
		marginBottom: 10
	},
	simpleRow: {
		display: 'flex',
		flexDirection: 'row',
		placeContent: 'center',
		justifyContent: 'space-between'
	},
	button: {
		display: 'flex',
		width: '70%',
		placeSelf: 'center',
		flexDirection: 'column',
		marginTop: 10,
		marginBottom: 30,
	}
}));

export const Formulaire = () => {

	const classes = useStyle();

	const [civilite, setCivilite] = React.useState();
	const changeCivilite = ({ target }: any) => {
		setCivilite(target.value);
	};

	const [name, setName] = React.useState();
	const changeName = ({ target }: any) => {
		setName(target.value);
	};

	const [surname, setSurname] = React.useState();
	const changeSurname = ({ target }: any) => {
		setSurname(target.value);
	};

	const [mail, setMail] = React.useState();
	const [mailError, setMailError] = React.useState(false);
	const changeMail = ({ target }: any) => {
		setMail(target.value);
	};
	const isMailValide = ({ target }: any) => {
		const isMatched = target.value.trim() ? target.value.match(/^([a-z0-9_-]+\.)*[a-z0-9_-]+@[a-z0-9_-]+(\.[a-z0-9_-]+)*\.[a-z]{2,6}$/gi) : false;
		if (isMatched) {
			setMailError(false);
		} else {
			setMailError(true);
		}
	};

	const [selected, setSelected] = React.useState('');
	const changeSelected = ({ target }: any) => {
		setSelected(target.value);
	};

	const [otherDemande, setOtherDemande] = React.useState('');
	const changeOtherDemande = ({ target }: any) => {
		setOtherDemande(target.value);
	};

	const [checkboxState, setCheckboxState] = React.useState({
		access: {
			isActive: false,
			text: '',
			title: "Droit d'accès"
		},
		rectification: {
			isActive: false,
			text: '',
			title: "Droit de rectification"
		},
		erasment: {
			isActive: false,
			text: '',
			title: "Droit à l'effacement"
		},
		retrait: {
			isActive: false,
			text: '',
			title: "Droit de retrait de consentement"
		},
		portability: {
			isActive: false,
			text: '',
			title: "Droit à la portabilité"
		},
		limitation: {
			isActive: false,
			text: '',
			title: "Droit à la limitation du traitement"
		}
	});
	const changeCheckboxState = (isActive: boolean, text: string, checkbox: 'access' | 'rectification' | 'erasment' | 'retrait' | 'limitation' | 'portability', title?: string) => {
		setCheckboxState({
			...checkboxState,
			[checkbox]: { isActive: isActive, text: text, title: title }
		});
		changeDetail();
	};
	const [detailCheckbox, setDetailCheckbox] = React.useState<string>();
	const changeDetail = () => {
		const format = "%0D%0A%20%20%20%20%20%20%20";
		let textDetail = format;
		Object.entries(checkboxState).forEach(([name, { isActive, text, title }]) => {
			if (isActive) {
				textDetail = `${textDetail} - ${title}: ${text ? text : 'sans detail suplémentaire'}${format}`;
			}
		});
		setDetailCheckbox(textDetail);
	};
	console.log(detailCheckbox);
	return (
		<>
			<Card className={classes.card} >
				<CardContent>
					<Typography children='Civilité*' color='textSecondary' gutterBottom />
					<FormControl required component='fieldset' >
						<RadioGroup onChange={changeCivilite} value={civilite} >
							<FormControlLabel value='Monsieur' control={<Radio color='primary' />} label='Monsieur' />
							<FormControlLabel value='Madame' control={<Radio color='primary' />} label='Madame' />
						</RadioGroup>
					</FormControl>
				</CardContent>
			</Card>

			<Card className={classes.card} >
				<CardContent>
					<Typography children='Identité' color='textSecondary' gutterBottom />
					<FormControl className={classes.simpleRow} component='fieldset' >
						<TextField required label='Nom' value={name} onChange={changeName} />
						<TextField required label='Prénom' value={surname} onChange={changeSurname} />
					</FormControl>
				</CardContent>
			</Card>

			<Card className={classes.card} >
				<CardContent>
					<Typography children='Adresse mail' color='textSecondary' gutterBottom />
					<TextField required helperText={mailError ? 'Votre adresse mail n\'est pas valide' : null} error={mailError} onBlur={isMailValide} label='Mail' value={mail} onChange={changeMail} fullWidth />
				</CardContent>
			</Card>

			<Card className={classes.card} >
				<CardContent>
					<Typography children='Objet de votre demande*' color='textSecondary' gutterBottom />
					<Select onChange={changeSelected} value={selected} fullWidth>
						<MenuItem value='Accès à mes données '>Accès à mes données </MenuItem>
						<MenuItem value='Rectification de mes données '> Rectification de mes données </MenuItem>
						<MenuItem value='Opposition et/ou non utilisation de mes données '> Opposition et/ou non utilisation de mes données </MenuItem>
						<MenuItem value='Portabilité de mes données '> Portabilité de mes données </MenuItem>
						<MenuItem value='Effacement de mes données '> Effacement de mes données </MenuItem>
						<MenuItem value='Retrait du consentement de mes données '> Retrait du consentement de mes données </MenuItem>
						<MenuItem value='Limitation du traitement de mes données '> Limitation du traitement de mes données </MenuItem>
					</Select>
				</CardContent>
			</Card>

			<Card className={classes.card} >
				<CardContent>
					<Typography children='Détail de votre demande*' color='textSecondary' gutterBottom />
					<FormGroup>
						<CheckboxDemand changeCheckboxState={(isActive: boolean, text: string, checkbox: 'access' = 'access') => changeCheckboxState(isActive, text, checkbox, "Droit d'accès")} text="Droit d'accès" adress='https://www.cnil.fr/fr/le-droit-dacces-connaitre-les-donnees-quun-organisme-detient-sur-vous' placeholder=" " />
						<CheckboxDemand changeCheckboxState={(isActive: boolean, text: string, checkbox: 'rectification' = 'rectification') => changeCheckboxState(isActive, text, checkbox, "Droit de rectification")} text='Droit de rectification' adress='https://www.cnil.fr/fr/le-droit-de-rectification-corriger-vos-informations' placeholder="Expliquez les rectifications souhaitées" />
						<CheckboxDemand changeCheckboxState={(isActive: boolean, text: string, checkbox: 'erasment' = 'erasment') => changeCheckboxState(isActive, text, checkbox, "Droit à l'effacement")} text="Droit à l'effacement" adress='https://www.cnil.fr/fr/le-droit-leffacement-supprimer-vos-donnees-en-ligne' placeholder=" " />
						<CheckboxDemand changeCheckboxState={(isActive: boolean, text: string, checkbox: 'retrait' = 'retrait') => changeCheckboxState(isActive, text, checkbox, "Droit de retrait de consentement")} text='Droit de retrait du consentement' adress='https://www.cnil.fr/fr/conformite-rgpd-comment-recueillir-le-consentement-des-personnes' placeholder="Indiquez les traitements des données à caractère personnel concernés" />
						<CheckboxDemand changeCheckboxState={(isActive: boolean, text: string, checkbox: 'limitation' = 'limitation') => changeCheckboxState(isActive, text, checkbox, "Droit à la limitation du traitement")} text='Droit à la limitation du traitement' adress='https://www.cnil.fr/fr/le-droit-la-limitation-du-traitement-geler-lutilisation-de-vos-donnees' placeholder="Indiquez les traitements de données à caractère personnel concernés" />
						<CheckboxDemand changeCheckboxState={(isActive: boolean, text: string, checkbox: 'portability' = 'portability') => changeCheckboxState(isActive, text, checkbox, "Droit à la portabilité")} text='Droit à la portabilité' adress='https://www.cnil.fr/fr/le-droit-la-portabilite-obtenir-et-reutiliser-une-copie-de-vos-donnees' placeholder=" " />
					</FormGroup>
				</CardContent>
			</Card>

			<Card className={classes.card} >
				<CardContent>
					<Typography children='Autre demande' color='textSecondary' gutterBottom />
					<TextField onChange={changeOtherDemande} value={otherDemande} fullWidth multiline />
				</CardContent>
			</Card>
			<Button variant='contained' color='primary' disabled={
				name && surname && mail && civilite && selected && !mailError
					? false
					: true
			} className={classes.button} href={`
        mailto:contacter.agr@caissedesdepots.fr
        ?subject= Protection des données personnelles
        &body=Civilité: ${civilite}%0D%0ANom: ${name}%0D%0APrénom: ${surname}%0D%0AAdresse mail: ${mail}%0D%0AObject de la demande: ${selected}%0D%0AAutre demande: ${otherDemande ? otherDemande : 'Pas d\'autre demande'}%0D%0ADetail de votre demande: ${detailCheckbox ? detailCheckbox : 'Pas de detail sur votre demande '}`
			} >Envoyer</Button>
			<div className={classes.button} >
				<Typography color='textSecondary' >
					Pour votre information : <Button size='small' href='https://www.cnil.fr/les-droits-pour-maitriser-mes-donnees-personnelles' > www.cnil.fr/les-droits-pour-maitriser-mes-donnees-personnelles </Button>
				</Typography>
			</div>
		</>
	);
};